
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("jouXW", function(module, exports) {

var $42omo = parcelRequire("42omo");

/* DecisionList.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $gMc0m = parcelRequire("gMc0m");




const $b95db5ab63622e0a$var$listStyles = null;
class $b95db5ab63622e0a$export$2e2bcd8739ae039 extends (0, $42omo.PureComponent) {
    render() {
        const { children: children } = this.props;
        if (!children) return null;
         // Data attributes are required for copy and paste from rendered content
        // to the editor to preserve the decision.
        // This allows the editor to differentiate between numbered and ordered lists,
        // and action items, which all share the common `<li>` element.
        // The value of `data-decision-local-id` should be discarded upon paste, with a
        // a new uuid generated by the editor for the cloned content.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ol", {
            "data-decision-list-local-id": "",
            "data-node-type": "decisionList",
            className: (0, $gMc0m.default)([
                "_1braglyw _1yxxidpf"
            ])
        }, (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(children, (child, idx)=>{
            const { localId: localId } = child.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("li", {
                key: idx,
                "data-decision-local-id": localId || '',
                "data-decision-state": "DECIDED"
            }, child);
        }));
    }
}


class $73ad23539db906c2$export$2e2bcd8739ae039 extends (0, $42omo.PureComponent) {
    render() {
        const { children: children } = this.props;
        if ((0, $42omo.Children).count(children) === 0) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b95db5ab63622e0a$export$2e2bcd8739ae039), null, children);
    }
}
module.exports["default"] = $73ad23539db906c2$export$2e2bcd8739ae039;

});


//# sourceMappingURL=decisionList.a46a7b0c.js.map
